import { signOut } from "@/features/auth"
import { clearReportUnlocks } from "@/features/today"

import LogoutIcon from "@/assets/img/profile/menu/logout.svg?react"

interface LogoutModalProps {
  onClose: () => void
}

/** "End your session?" confirmation sheet. Ported from ProfileV4 LogOutModal. */
export function LogoutModal({ onClose }: LogoutModalProps) {
  const handleLogout = async () => {
    // Drop in-progress report timers so the reports show as available (the
    // server "purchased" entitlement) instead of resuming a stale countdown.
    clearReportUnlocks()
    await signOut()
    window.location.href = "/"
  }

  return (
    <div className="fixed inset-0 z-[1100] mx-auto flex min-h-[100dvh] w-full max-w-app flex-col justify-end bg-dark-base/80 backdrop-blur-[10px]">
      <div className="flex flex-col items-center gap-4 rounded-t-3xl bg-dark-surface px-4 pb-4 pt-6">
        <div className="flex size-24 items-center justify-center rounded-full bg-peach/10 text-peach [&_svg]:size-10">
          <LogoutIcon />
        </div>

        <div className="flex flex-col gap-2 text-center">
          <h2 className="font-display text-2xl font-medium text-purple-light">End your session?</h2>
          <p className="font-body text-base text-purple-light/70">
            You can always sign back in to see your reports and insights.
          </p>
        </div>

        <div className="flex w-full items-center gap-3">
          <button
            type="button"
            onClick={onClose}
            className="h-14 flex-1 rounded-full bg-purple-light/10 font-body text-base font-semibold text-purple-light"
          >
            Stay here
          </button>
          <button
            type="button"
            onClick={handleLogout}
            className="h-14 flex-1 rounded-full bg-peach font-body text-base font-semibold text-white"
          >
            Log out
          </button>
        </div>
      </div>
    </div>
  )
}
